<template>
  <div>

      <el-form label-width="120px" :inline="true" size="mini"
               :model="addForm"
               ref="addForm"
               :rules="rules">
        <el-row v-show="productPage">
          <el-col>
              <el-form-item label="险种方案标题" prop="keywords">
                <el-input placeholder="请输入险种方案标题" @input="searchProductMd" v-model="searchForm.keywords" />
              </el-form-item>

              <el-form-item   v-for="(item,index) in productNameList" :key="index">
                <el-button round  :class="{'selected': selectedButton === item.id}"  @click.native="searchClick('',item.id)">{{ item.name }}</el-button>
              </el-form-item>
              <el-form-item >
                  <el-button round type="primary" @click="searchClick2">
                      重置
                  </el-button>
              </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
          <div v-if="(source==2 && total>=100) || (source!=2)">
            <el-table
                ref="productMTable"
                :data="productMList"
                stripe
                border
                size="mini" highlight-current-row
                :header-cell-style="{background:'#e5e5e5',color:'#333333'}"
            >

              <el-table-column
                  label="险种方案标题"
                  prop="product_md_title"
                  min-width="9%"
                  :show-overflow-tooltip='true' align="center">
              </el-table-column>
              <el-table-column
                  label="基本信息"
                  align="center"
                  min-width="91%"
              >
                <template slot-scope="scope">
                  <!--                <el-descriptions :column="1"  border align="center" size="mini">-->
                  <!--                  <el-descriptions-item label="险种标题" align="center"><p>-->
                  <!--                    {{ scope.row.product_md_title }}-->
                  <!--                  </p></el-descriptions-item>-->
                  <!--                </el-descriptions>-->
                  <el-descriptions direction="vertical" border :column="2" align="center" size="mini" :colon="false">
                    <el-descriptions-item align="center" label="产品优势">
                      <div style="text-align: center;width: 100%">
                        <span @click="readNoticeBx(scope.row)" style="color: #ff0000;">保费保障</span>
                      </div>


                    </el-descriptions-item>

                    <el-descriptions-item :label="scope.row.product_md_title" align="center">

                      <el-table
                          ref="productMTable"
                          :data="scope.row.children"
                          stripe
                          border
                          size="mini"
                      >
                        <el-table-column
                            label="标题" prop="title" min-width="20%"
                            :show-overflow-tooltip='true'>

                        </el-table-column>
                        <el-table-column
                            label="保费" min-width="10%"
                            prop="real_price"
                            :show-overflow-tooltip='true'>
                        </el-table-column>

                        <el-table-column
                            label="净费" min-width="10%"
                            prop="sell_price"
                            :show-overflow-tooltip='true'>

                        </el-table-column>
                        <el-table-column
                            label="投保告知" min-width="10%"
                            :show-overflow-tooltip='true'>
                          <template slot-scope="scopes">
                            <span @click="readNotice(scope.row.cpys,scopes.row)" style="color: #ff0000">投保告知</span>
                          </template>
                        </el-table-column>
                        <el-table-column
                            label="承保要求" min-width="10%"

                            :show-overflow-tooltip='true'>
                          <template slot-scope="scopes">
                            <span @click="readNotice2(scope.row.desc,scopes.row)" style="color: #ff0000">承保要求</span>
                          </template>
                        </el-table-column>
                        <el-table-column
                            label="方案保障" min-width="10%"

                            :show-overflow-tooltip='true'>
                          <template slot-scope="scope">
                            <span @click="readNotice3(scope.row)" style="color: #ff0000">方案保障</span>
                          </template>
                        </el-table-column>

                        <el-table-column label="选择" align="center" min-width="10%">
                          <template slot-scope="scope2">
                            <el-button style="width: 100%;height: 100%" v-model="currM" :label="scope.row" @click="clickChange(scope.row,scope.$index,scope2.row,scope2.$index+1)">{{selectText}}</el-button>
                          </template>
                        </el-table-column>
                        <el-table-column
                            label="操作" min-width="10%">
                          <template slot-scope="scope2">
                            <el-button style="width: 100%;height: 100%" type="primary" v-if="(currIndex==scope.$index+1)&&!isUsed"  icon="el-icon-edit" @click="okProduct(scope.row,scope.$index,scope2.row,scope2.$index)">确认</el-button>
                            <el-button style="width: 100%;height: 100%"  v-if="isUsed" icon="el-icon-edit" @click="cancelChooseProduct(scope2.row,scope2.$index+1)">取消</el-button>
                          </template>
                        </el-table-column>

                      </el-table>

                    </el-descriptions-item>

                    <el-descriptions-item label="险种优势" align="center">
                      {{ scope.row.product_good ? scope.row.product_good : scope.row.product_type_name }}

                    </el-descriptions-item>
                  </el-descriptions>
                </template>
              </el-table-column>

            </el-table>
          </div>
          <div class="else" v-else>
            车辆需超100台才能查看产品方案
          </div>
            <div class="block" style="margin-top:10px" v-show="productPage">
              <el-pagination
                background
                @size-change="handleSizeChangeP"
                @current-change="handleCurrentChangeP"
                :current-page="pageNumP"
                :page-sizes="[5,10, 20, 30, 100]"
                :page-size="pageSizeP"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalP">
              </el-pagination>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="24" style="display: none">
          <el-col :span="8">
            <el-form-item label="保险方案名称" >
              <el-input style="width: 180px;" v-model="addForm.product_md_name" prefix-icon="el-icon-search" @click.native.prevent="chsProduct"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="保险名称" prop="product_name">
              <el-input style="width: 180px;" v-model="addForm.product_name"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="保险公司" prop="remark">
              <el-input style="width: 180px;" v-model="addForm.corp_name"/>
            </el-form-item>
          </el-col>

        </el-row>

        <el-row :gutter="24">
          <el-col :span="4">
            <div >
                <el-button type="primary" style="width: 100%"  @click="addItem">选择车辆</el-button>

              </div>
            <el-table v-if="carGroups.length>0" :data="carGroups" border height="240px" size="mini" show-summary  stripe>
              <el-table-column prop="allPerson" min-width="16%" label="所属人" align='center' :show-overflow-tooltip='true'>

              </el-table-column>
              <el-table-column prop="credit_code" min-width="10%" label="证件" align='center' :show-overflow-tooltip='true'>
              <template slot-scope="scope">
              {{scope.row.credit_code}}
              </template>
              </el-table-column>
              <el-table-column prop="num" min-width="8%" label="投保台次" align='center' :show-overflow-tooltip='true'>
              <template slot-scope="scope">
              <span style="color: #ff0000">{{scope.row.num}}</span>
              </template>
              </el-table-column>

            </el-table>



            <div v-else style="text-align: center;color: #3a8ee6;padding-top: 100px;">
              <h4>请选择车辆之后，然后展示所属人和所选台次统计信息！
              </h4>
            </div>
            <div style="text-align: center;">

              <el-button @click="close">取消</el-button>
              <el-button type="primary" @click="save('addForm')">保存</el-button>

            </div>
          </el-col>
          <el-col :span="20">
            <div class="table_box">

              <el-table :data="list" border height="300px" size="mini" :summary-method="getSummaries" show-summary style="width: 100%;" stripe>
                <el-table-column prop="allPerson" min-width="10%" label="所属人/公司" align='center' :show-overflow-tooltip='true'>

                </el-table-column>
                <el-table-column prop="plate_number" min-width="8%" label="车辆车牌号" align='center' :show-overflow-tooltip='true'>
                  <template slot-scope="scope">
                    <span v-if="!scope.row.isEgdit">{{scope.row.plate_number}}</span>
                    <el-input  size="mini" prefix-icon="el-icon-search" @click.native.prevent="chooseCar(scope.$index)" v-if="scope.row.isEgdit" v-model="scope.row.plate_number"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="vin" min-width="15%" label="车架号" align='center' :show-overflow-tooltip='true'>

                </el-table-column>
                <el-table-column min-width="10%" prop="vehicle_type" label="车辆类型" align='center' :show-overflow-tooltip='true'>
                </el-table-column>
<!--                <el-table-column min-width="10%" prop="policy_no" label="投保单号" align='center' :show-overflow-tooltip='true'>-->
<!--                  <template slot-scope="scope">-->
<!--                    <el-input size="mini" v-model="scope.row.policy_no"></el-input>-->
<!--                  </template>-->
<!--                </el-table-column>-->
<!--                <el-table-column min-width="10%" prop="proposal_form" label="保单号" align='center' :show-overflow-tooltip='true'>-->
<!--                  <template slot-scope="scope">-->
<!--                    <el-input size="mini" v-model="scope.row.proposal_form"></el-input>-->
<!--                  </template>-->
<!--                </el-table-column>-->
                <el-table-column min-width="8%" prop="real_price" label="保费" align='center' :show-overflow-tooltip='true'>
                  <template slot-scope="scope">
                    {{ scope.row.real_price }}
                  </template>
                </el-table-column>
<!--                <el-table-column min-width="7%" prop="price" label="净费" align='center' :show-overflow-tooltip='true'>-->
<!--                  <template slot-scope="scope">-->
<!--                    <el-input size="mini" v-model="scope.row.price"></el-input>-->
<!--                  </template>-->
<!--                </el-table-column>-->
                <el-table-column min-width="8%" prop="sell_price" label="净费" align='center' :show-overflow-tooltip='true'>
                  <template slot-scope="scope">
<!--                    <el-input size="mini" v-model="scope.row.sell_price"></el-input>-->
                    {{scope.row.sell_price}}
                  </template>
                </el-table-column>
                <el-table-column min-width="7%" prop="time_limit" label="车龄" align='center' :show-overflow-tooltip='true'>
                  <template slot-scope="scope">
                    {{ scope.row.time_limit }}
                  </template>
                </el-table-column>
                <el-table-column min-width="12%"  prop="order_date" label="投保日期" align='center' :show-overflow-tooltip='true'>
                  <template slot-scope="scope">
                    <span v-if="!scope.row.isEgdit">{{scope.row.effective_date}}</span>

                    <el-date-picker
                      size="mini"
                      style="width: 150px;"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      v-if="scope.row.isEgdit"
                      v-model="scope.row.effective_date"
                      type="date"
                      placeholder="选择投保日期">
                    </el-date-picker>
                  </template>
                </el-table-column>

                <el-table-column min-width="12%"  prop="start_date"  label="保险起期" align='center' :show-overflow-tooltip='true'>
                  <template slot-scope="scope">
                    <span v-if="scope.row.isEgdit">{{scope.row.start_time}}</span>
                    <el-date-picker
                      @change="startDateChange($event,scope.$index,scope.row.register_date)"
                      size="mini"
                      style="width: 150px;"
                      :picker-options="pickerOptions1"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      v-if="!scope.row.isEgdit"
                      v-model="scope.row.start_time"
                      type="datetime"
                      placeholder="选择投保日期">
                    </el-date-picker>
                  </template>
                </el-table-column>

                <el-table-column min-width="12%" prop="end_date"  label="保险止期" align='center' :show-overflow-tooltip='true'>
                  <template slot-scope="scope">
                    <span v-if="!scope.row.isEgdit">{{scope.row.end_time}}</span>
                    <el-date-picker
                      size="mini"
                      style="width: 150px;"
                      value-format="yyyy-MM-dd"
                      v-if="scope.row.isEgdit"
                      v-model="scope.row.end_time"
                      type="date"
                      placeholder="选择投保日期">
                    </el-date-picker>
                  </template>
                </el-table-column>

                <el-table-column min-width="5%" label="操作" align='center'>
                  <template slot-scope="scope">
                    <el-button @click.native.prevent="deleteItem(scope.$index, list)" type="danger" size="mini" icon="el-icon-delete" circle></el-button>
                  </template>
                </el-table-column>

              </el-table>
            </div>

          </el-col>
        </el-row>

      </el-form>

    <el-dialog width="70%" :title="readNoticeTitle" :visible.sync="noticeVisible" :close-on-click-modal="false" lock-scroll :close-on-press-escape="false"  :show-close="false">
      <div>
        {{cpys}}
      </div>
      <el-row>
        <el-col style="padding-top: 10px;display:flex;flex-direction: row;justify-content: flex-end;">
          <el-button  size="mini" type="primary" @click="okRead">已阅读</el-button>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog width="70%" :title="titleBx" :visible.sync="noticeBXVisible" :close-on-click-modal="false" lock-scroll :close-on-press-escape="false"  :show-close="false">
      <div>
        <el-descriptions direction="vertical" :column="1" border align="center" size="mini">

<!--            货物险-->
          <el-descriptions-item label="保费保障" v-if="noticeBXData.product_type_id==13">
              <el-table
                :data="noticeBXData.insure_clause"
                stripe border>
                <el-table-column
                  prop="car_type"
                  label="车辆类型" :show-overflow-tooltip='true'>
                </el-table-column>
                <el-table-column
                  prop="baoe"
                  label="保额（单次及累次）" :show-overflow-tooltip='true'>
                </el-table-column>
                <el-table-column
                  prop="baofei"
                  label="保费" :show-overflow-tooltip='true'>
                </el-table-column>

                <el-table-column
                  prop="tiaokuan"
                  label="承保要求" :show-overflow-tooltip='true'>
                </el-table-column>

              </el-table>

          </el-descriptions-item>
          <el-descriptions-item label="保障条款投保提示" v-if="noticeBXData.product_type_id==13">
            {{noticeBXData.insure_tips}}
          </el-descriptions-item>
<!--            超赔险-->
          <el-descriptions-item label="保费保障" v-else-if="noticeBXData.product_type_id==14">
              <el-table
                :data="noticeBXData.insure_clause"
                stripe border>
                <el-table-column
                  prop="cplx"
                  label="类型" :show-overflow-tooltip='true'>
                </el-table-column>
                <el-table-column
                  prop="mcsgpcxe"
                  label="每次事故赔偿限额" :show-overflow-tooltip='true'>
                </el-table-column>
                <el-table-column
                  prop="nljpcxe"
                  label="年累计赔偿限额" :show-overflow-tooltip='true'>
                </el-table-column>
                <el-table-column
                  prop="baofei"
                  label="年保费" :show-overflow-tooltip='true'>
                </el-table-column>


              </el-table>
          </el-descriptions-item>
<!--            雇主和驾乘，交强，商业险-->
          <el-descriptions-item label="保费保障" v-else>
              <el-table
                :data="noticeBXData.insure_clause"
                stripe border>
                <el-table-column
                  prop="bzzr"
                  label="保障责任" :show-overflow-tooltip='true'>
                </el-table-column>
                <el-table-column
                  prop="baofei"
                  label="保费" :show-overflow-tooltip='true'>
                </el-table-column>
                <el-table-column
                  prop="baoe"
                  label="保额" :show-overflow-tooltip='true'>
                </el-table-column>
                <el-table-column
                  prop="mianpei"
                  label="免赔" :show-overflow-tooltip='true'>
                </el-table-column>
                <el-table-column
                  prop="tiaokuan"
                  label="承保要求" :show-overflow-tooltip='true'>
                </el-table-column>

              </el-table>
          </el-descriptions-item>

          <el-descriptions-item label=" 特约简述 / 特别约定 ">

            <div v-html="formatRichText(noticeBXData.insure_appoint)"></div>

          </el-descriptions-item>
        </el-descriptions>
      </div>
      <el-row>
        <el-col style="padding-top: 10px;display:flex;flex-direction: row;justify-content: flex-end;">
          <el-button  size="mini" type="primary" @click="okReadBx">已阅读</el-button>
        </el-col>
      </el-row>
    </el-dialog>
<!--    车辆列表-->
    <el-dialog width="750px" top="2%" title="车辆列表" :visible.sync="productVisible" @close="closeProduct" style="margin: 0px 0px 0px 44%;">
      <el-form size="mini" :model="searchForm1" ref="searchForm1" :inline="true">
        <el-form-item label="关键字名称" prop="keywords">
          <el-input   v-model="searchForm1.keywords" placeholder="请输入车架号|车牌"/>
        </el-form-item>
        <el-form-item label="所属人" prop="allPerson">
          <el-input   v-model="searchForm1.allPerson" placeholder="请输入所属人"/>
        </el-form-item>
        <el-form-item prop="name">
          <el-button type="primary" @click="searchCar">查询</el-button>
        </el-form-item>
        <div>
          <el-table :data="productList" border  size="mini" stripe height="180">
            <el-table-column label="选择" align="center" width="55">
              <template slot-scope="scope">
                <el-checkbox
                        :label="scope.$index"
                        v-model="scope.row.checked"
                        @change.native="getCurrentRow(scope.row,scope.$index)"
                        :disabled="scope.row.disabled"
                >&nbsp;</el-checkbox>
              </template>
            </el-table-column>
            <el-table-column
                    prop="plate_number"
              :show-overflow-tooltip='true'
              label="车辆号码">
            </el-table-column>
            <el-table-column
              width="180"
              prop="allPerson"
              :show-overflow-tooltip='true'
              label="所属人">
            </el-table-column>
            <el-table-column
              width="120"
              prop="vehicle_type"
              :show-overflow-tooltip='true'
              label="车辆类型">
            </el-table-column>
            <el-table-column
              prop="vin"
              width="150"
              :show-overflow-tooltip='true'
              label="车架号">
            </el-table-column>
            <el-table-column
              prop="model"
              width="180"
              :show-overflow-tooltip='true'
              label="品牌型号">
            </el-table-column>
            <el-table-column
              width="120"
              :show-overflow-tooltip='true'
              prop="use_character"
              label="使用性质">
            </el-table-column>
            <el-table-column
              width="120"
              :show-overflow-tooltip='true'
              prop="out_to_out"
              label="外廓尺寸">
            </el-table-column>
            <el-table-column
              width="120"
              :show-overflow-tooltip='true'
              label="挂车车牌号">
            </el-table-column>
            <el-table-column
              width="120"
              :show-overflow-tooltip='true'
              label="挂车类型">
            </el-table-column>
          </el-table>
          <div class="block" style="margin-top:10px">
            <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pageNum"
              :page-sizes="[10, 20, 30,50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
<!--        <el-row>-->
<!--          <el-col style="padding-top: 10px;display:flex;flex-direction: row;justify-content: flex-end;">-->
<!--            <el-button size="mini" @click="productVisible = false">取消</el-button>-->
<!--            <el-button  size="mini" type="primary" @click="okCar">确定</el-button>-->
<!--          </el-col>-->
<!--        </el-row>-->
      </el-form>
    </el-dialog>

  </div>
</template>
<script>
import moment from 'moment';
import empty from "element-ui/packages/empty";
import DOMPurify from 'dompurify';
export default {
  name:'UnionProductOrder',
  data(){
    return {
      selectedButton:-1,
      // +++++======选择业务渠道====+++++
      tableLoadData: [],
      page: 1,// 当前页码
      limit: 5,// 每页大小
      page2: 1,// 当前页码2
      limit2: 10,// 每页大小2
      total2: 0,//总条目数2

      busDialog: false,
      busTableData: [],
      dialogFormVisible: false,
      form: {
        role_name: '',
        position: '',
        role_id: '',
        status: '',
      },
      titleMember: '',
      // +++++======选择业务渠道==end==+++++
      productPage:true,
      productNameList:"",
      readNoticeTitle:'',
      isUsed:false,
      selectText:'未选择',
      pickerOptions1:{
        disabledDate(time) {
          return time.getTime() <= Date.now() ;
        }
      },
      carGroups:[],
      noticeVisible:false,
      isRead:false,
      currIndex:'',
      currProductIndex:'',
      currM:'',
      pageSize:10,
      pageNum:1,
      total:0,
      pageSizeP:5,
      pageNumP:1,
      totalP:0,
      shopList:'',
      applicantLoading:false,
      applicantList:[],
      applicantStates:[],

      cpys:'',
      corp:'',
      corpLoading:'',
      corpList:[],
      corpStates:[],

      isShowCar:false,
      isShowProduct:false,

      productList:[],
      productMList:[],
      productVisible:false,
      index:0,
      pIndex:-1,
      carIndex:0,
      productId:[],
      options: [],
      carList: [],
      loading: false,
      states: [],

      searchForm:{
        keywords:"",
        shop_id:'',
        product_id:''
      },
      searchForm1:{
        keywords:"",
        allPerson:''
      },
      addForm:{
        type:2,
        product_md_name:'',
        product_paren_id:'',
        product_md_id:'',
        contact_name:'',
        contact_mobile:'',
        real_price:'',
        price:'',
        sell_price:'',
        owner_id:'',

        owner_name:'',
        owner_idcard:'',
        owner_mobile:'',

        shop_id:'',
        member_id:'',
        member_name:'',
        toubao_name:'',
        toubao_idcard:'',
        toubao_mobile:'',

        corp_name:"",
        plate_number:'',
        car_id:'',
        applicant:'',
        applicant_tel:'',
        applicant_idcard:'',
        insured:"",
        insured_idcard:"",
        insured_tel:"",
        link_name:'',
        link_tel:'',
        remark:'',

        company_id:sessionStorage.getItem('company_id'),
        access_token:sessionStorage.getItem('token'),
      },
      rules: {
        applicant: [{ required: true, message: '请输入投保人', trigger: 'blur' }],
        insured: [{ required: true, message: '请输入被投保人', trigger: 'blur' }],
      },
      searchRules: {
        name: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
        ],
      },
      title:'保单新增',
      car_number:'',
      fileList:[],
      activeName: 'first',
      insurance_date:'',
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      list: [],
      link_name:'',
      link_tel:'',
      //保费保障-open弹出层
      noticeBXVisible:false,
      noticeBXData:[],
      titleBx:'',
      //保费保障-end弹出层
      reneInfo:[],
      source:1 //source
    }
  },

  created() {
    this.source = sessionStorage.getItem("source");

     // true 代表为对象
    if(this.$route.query.reneInfo && this.$route.query.reneInfo.__proto__ === Object.prototype)
    {
      this.reneInfo = this.$route.query.reneInfo;
      //console.log("reneInfo:",this.reneInfo);
      this.outoRene();
    }else{
      this.getCarList();
    }
    this.total = 101;//todo  等对接完后要去掉
    this.getProductMList('mounted');
    this.getProductList()
    let str = sessionStorage.getItem('userName')+' '+moment().format("yyyy-MM-DD HH:mm:ss")
  },
  filters: {
    // 时间格式化
    dateFormat(add_time) {
      if (add_time == undefined) {
        return "";
      }
      return moment(add_time * 1000).format("yyyy-MM-DD HH:mm:ss");
    },
  },
  methods:{
    //获取登录信息

    //根据传来的数据，自动选择保单、车辆去续保
    outoRene(){
      if(this.reneInfo)
      {
       // this.reneInfo
        this.searchClick('',this.reneInfo.product_id) //根据险种重置产品
        this.searchForm1.keywords = this.reneInfo.plate_number //product_paren_id
        this.getCarList()
        //起保日期，end_time
        var day;
        if(this.reneInfo.end_day <= 0)
        {
          day = this.getToubaoDate(1);

        }else{
          //var day = this.getNowDate(0,0,0);
          day = this.getToubaoDate(this.reneInfo.end_day)
          console.log('day',day)
        }
        this.reneInfo.star_times = day
        let tmp=new Date(day);
        this.reneInfo.end_times = this.getNextYearDay(tmp);
      }
      //this.getCarList();
    },
    searchCar(){
      this.getCarList();
    },
    beforeAvatarUpload(){

    },
    handleAvatarSuccess(){
      ////console.log('lu------',item.raw)
      this.imageUrl = URL.createObjectURL(item.raw);
      let file = item.raw;
      let _this=this;

    },
    searchClick(val,pid=0){

      this.currIndex='';
      // this.searchForm.keywords=val;
      this.selectedButton = pid;
      this.productMList=[];
      this.searchForm.product_id = pid;
      this.getProductMList();
    },
      searchClick2(){
        this.searchForm = {
            keywords:"",
            shop_id:'',
            product_id:''
          };
          this.getProductMList();
      },

    okProduct(row,index,row2,index2){

      this.addForm.product_md_id=row2.id;
      this.addForm.product_id=row2.product_id;
      this.addForm.contact_name=row2.contact_name;
      this.addForm.contact_mobile=row2.contact_mobile;
      this.addForm.real_price=row2.real_price;
      this.addForm.price=row2.price;
      this.addForm.sell_price=row2.sell_price;

      let tmp= this.productMList[index];
      let tmpSon = tmp.children[index2];
      this.productMList=[];
      tmp.children = [];
      tmp.children.push(tmpSon)
      this.productMList.push(tmp)
      this.isUsed=true;
      this.productPage = false;
    },
    cancelChooseProduct(row,idx){
      location.reload();
      this.currIndex='';
      this.productMList=[];
      this.getProductMList();
      this.isUsed=false;
      this.productPage = true;
    },
    okRead(){
      this.noticeVisible=false;
      this.isRead=true;
    },
    readNotice(cpys,row){
      this.readNoticeTitle = '投保告知';
      if(cpys){
        this.cpys = cpys
      }else{
        this.cpys = row.cpys
      }
      this.noticeVisible=true;
    },
    readNotice2(desc,row){
      this.readNoticeTitle = '承保要求';
      if(desc){
        this.cpys = desc
      }else{
        this.cpys = row.desc
      }
      this.noticeVisible=true;
    },
    readNotice3(row){
      this.readNoticeTitle = '方案保障';
      this.cpys = row.remark
      this.noticeVisible=true;
    },
    openNoticeDialog(row){
      this.noticeVisible=true;
    },
    searchProductMd(){
      this.productMList=[];
      this.searchForm.product_id = 0;
      this.getProductMList();
    },
    handleSizeChange(newSize){
      this.pageSize = newSize
      this.getCarList()
    },
    handleCurrentChange(newPage){
      this.pageNum = newPage
      this.getCarList();
    },
    handleSizeChangeP(newSize){
      this.pageSizeP = newSize
      this.getProductMList()
    },
    handleCurrentChangeP(newPage){
      this.pageNumP = newPage
      this.getProductMList();
    },
    // 新增
    addData() {
      this.$router.push('/insuranceAdd');
    },
    addByProduct(){
      this.$router.push('/insuranceAddByProduct');
    },
    addSysProduct(){
      this.$router.push('/insuranceSysProduct');
    },
    addSysCar(){
      this.$router.push('/insuranceSysCar');
    },
    getCurrentRow(row,index){
      //console.log(row)
      if(row.checked)
      {
        if(this.list.length>0){
          for (var i=0;i<this.list.length;i++){
            if(this.list[i].plate_number==row.plate_number){
              this.$message.error("车辆不能重复添加");
              return;
            }
          }
        }

          this.productList[index].checked = true
          this.productList[index].carIndex = this.carIndex

        let item = {
          plate_number:row.plate_number,
          allPerson:row.allPerson,
          credit_code:row.shop.credit_code,
          vehicle_type:row.vehicle_type,
          vin:row.vin,
          out_to_out:row.out_to_out,
          model:row.model,
          car_id:row.id,
          fee:0,
          register_date:row.register_date,
          effective_date:this.getNowTime(),
          start_time:'',
          end_time:'',
          fruitSort: null,
          firstNum: null,
          isEgdit: false,
          shop_id:row.shop_id,
          contact_name:'',
          contact_mobile:'',
          file_url:'',
          owner_id:row.owner_id,
          fileList:[],
          real_price:this.addForm.real_price,
          price:this.addForm.price,
          sell_price:this.addForm.sell_price,
          policy_no:'',
          proposal_form:'',
          time_limit:'无'
        }
        if(this.reneInfo && this.reneInfo.star_times)
          item.start_time = this.reneInfo.star_times
        if(this.reneInfo && this.reneInfo.end_times)
          item.end_time = this.reneInfo.end_times
        this.list.push(item)
        this.carGroups=[];
        let json= this.arrayGroupBy(this.list,'allPerson');
        //console.log('arrayGroupBy-----',json)
        let tmpList=[];
        let {keys,values,entries} = Object
        for (const [key,val] of entries(json)) {
          let reg = new RegExp('"',"g");
          let newKey = key.replace(reg, "");
          tmpList.push({
            type:newKey,
            data:val
          })
        }
        //console.log('arrayGroupBy_rs-----',tmpList)
        if(tmpList.length>0){
          for (var i=0;i<tmpList.length;i++){
            let itm={
              allPerson:tmpList[i].type,
              credit_code:tmpList[i].data[0].credit_code,
              num:tmpList[i].data.length
            }
            this.carGroups.push(itm);
          }
        }
      }else{
        this.productList[index].checked = false
        this.list.forEach((lItem, Lindex)=>{
          if(lItem.plate_number == this.productList[index].plate_number)
          {
            this.$delete(this.list, Lindex);
          }
        })
      }
      //console.log('carlist-list',this.list)
      //console.log('productList-list',this.productList)

    },
    getCarList(){
      const param = {
        company_id:sessionStorage.getItem('company_id'),
        access_token:sessionStorage.getItem('token'),
        page:this.pageNum,
        pageSize:this.pageSize,
      }
      if(this.searchForm1.keywords){
        param.queryParams=this.searchForm1.keywords;
      }
      if(this.searchForm1.allPerson){
        param.allPerson=this.searchForm1.allPerson;
      }
      if(this.addForm.product_paren_id){
        param.product_paren_id=this.addForm.product_paren_id;
      }
      if(this.addForm.product_md_id){
        param.product_md_id=this.addForm.product_md_id;
      }
      //将json数据转成js对象
      this.$axios.getCarFilesInfoList(param).then(res=>{

        if(res.code == 200){ //&&res.data.total>0
            this.productList = res.data.data;
           // this.total = res.data.total; //todo  等对接完后要放开
            //console.log('total2:',this.total);
            for(let key in this.productList){
              this.$set(this.productList[key],'checked',false);
            }
        }else{
            this.productList = [];
            this.total = 0;
            this.$message.error(res.msg);
        }
      }).catch(error=>{
        //console.log(error);
      })
    },

    chooseProductInfo(product_md_name,...params){

      this.addForm.product_md_name=product_md_name;
      this.addForm.product_md_id=params[0];
      this.addForm.corp_name=params[1];
      this.addForm.product_name=params[2];

    },
    chooseCarInfo(plate_number,...params){
      this.addForm.plate_number=plate_number;
      this.addForm.car_id=params[0];
    },
    handleClick(){

    },
    closeProduct(){

    },
    okCar(){
      this.productVisible=false;
    },
    chooseCar(index){
      this.productVisible=true;
      this.carIndex=index;
      //console.log('chooseCar--index',index);
      //console.log('chooseCar--carIndex',this.carIndex);
    },
    chsProduct(){
      this.isShowProduct=true;
    },
    remoteMethod(query) {
      if (query !== '') {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.options = this.carList.filter(item => {
            return item.name.indexOf(query) > -1;
          });
        }, 200);
      } else {
        this.options = [];
      }
    },
    onClose(){
      this.$emit('close')
    },
    close(){
      this.$emit('close')
    },
    handleBeforeUpload(){

    },
    uploadSuccess(){

    },

    handleChange(file,fileList,index){
      let _this=this;

      //------上传到阿里云
      let carFd = new FormData()
      carFd.append('file', file.raw)
      carFd.append('file_type', 1)
      // carFd.append('file_value', this.addForm.vin)
      carFd.append('company_id', sessionStorage.getItem('company_id'))
      carFd.append('access_token', sessionStorage.getItem('token'))
      this.$axios.ossUploadFile(carFd).then(res11 => {

        //console.log('aliyun--------',res11)
        if (res11.code == 200) {
          this.$message.success(res11.msg)
          _this.list[index].file_url = res11.data.src;
          //console.log('file_url--------', _this.list[index].file_url)

        } else if (res11.code == 1) {
          this.$message.error(res11.msg)
        }
      }).catch(function (error) {
        //console.log(error);
      })
      //------上传到阿里云
    },
    save(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var param={
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
            data:[]
          };

          for (var j=0;j<this.list.length;j++){
            if(this.list[j].sell_price<=0){
              this.$message.error('请先联系保险顾问，设置净费')
              return false
            }
            // if(this.list[j].sell_price<=0){
            //   this.$message.error('请输入外放净费')
            //   return false
            // }
            var pm={
              type:2,
              shop_id:this.list[j].shop_id,
              owner_id:this.list[j].shop_id,
              owner_name:this.list[j].allPerson,
              owner_idcard:"1",
              owner_mobile:"1",
              toubao_name:this.list[j].allPerson,
              toubao_idcard:"1",
              toubao_mobile:"1",
              car_id:this.list[j].car_id,
              product_id:this.addForm.product_id,
              product_md_id:this.addForm.product_md_id,
              time_limit:this.list[j].time_limit,
              pay_id:0,
              corp_id:this.addForm.corp_id,
              sell_price:this.list[j].sell_price,
              price:this.list[j].price,
              real_price:this.addForm.real_price,
              proposal_form:this.list[j].proposal_form,
              policy_no:this.list[j].policy_no,
              member_id:this.addForm.member_id,
              member_name:this.addForm.member_name,
              effective_date:this.list[j].effective_date,
              end_time:this.list[j].end_time,
              start_time:this.list[j].start_time,
              file_url:this.list[j].file_url,
              shoukuan_type:1,//收款方式
              account:'',
              account_number:'',

              pay_date:'',
              payee_account:'',
              pay_remark: "",
              pay_money: 1,
              payee_account_number: "",
              title: "",
              payee_bank_name: "",
              account_bank_name: "",
              big_amount: "",
              small_amount: "",
              bank_receipt_sn: "",
              receipt_sn: "",
              bank_desc: "",
              bank_use: "",
              bank_date: "",
              remark:'',
            };
            param.data.push(pm)
          }

          this.$axios.saveOrderBySysProduct(param).then(res =>{
            // console.log('团单保存-res-param',param);
            // console.log('团单保存-res-data',res);
            if(res.code == 200){
              this.$message.success(res.msg)
              this.$router.push('/insuranceSysTeamOrder')
            }else{
              this.$message.error(res.msg);
            }
          })
        }
      });
    },
    dealSpace(str){
      return str.replace(/&nbsp;/gi, " ");
    },
    //合计 表格每一列需要带上prop
    getSummaries(param) {

      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计净费';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return Math.round((prev+curr)*100)/100;
            } else {
              return prev;
            }
          }, 0);
          sums[index] += '(元)';
        } else {
          sums[index] = '';
        }
      });

      return sums;
    },
    //新增数据
    addItem() {
      //必须选完险种方案才能添加车辆
      if(this.currIndex<=0){
        this.$message.error('请先选择险种方案，才能选车');
        return false;
      }
      this.productVisible=true;

    },
    //删除数据
    deleteItem(index, list) {
      if(this.index>0){
        this.index=this.index-1;
      }
      this.pIndex = -1;
      list.splice(index, 1);
      //console.log('deleteItem-index',index);
      //console.log('deleteItem-pIndex',this.pIndex);
      //console.log('deleteItem-list',list);
      this.carGroups=[];
      let json2= this.arrayGroupBy(list,'allPerson');
      //console.log('deleteItem-arrayGroupBy-----',json2)
      let tmpList2=[];
      let {keys,values,entries} = Object
      for (const [key,val] of entries(json2)) {
        let reg = new RegExp('"',"g");
        let newKey = key.replace(reg, "");
        tmpList2.push({
          type:newKey,
          data:val
        })
      }
      //console.log('deleteItem-arrayGroupBy_rs-----',tmpList2)
      if(tmpList2.length>0){
        for (var i=0;i<tmpList2.length;i++){
          let itm={
            allPerson:tmpList2[i].type,
            credit_code:tmpList2[i].data[0].credit_code,
            num:tmpList2[i].data.length
          }
          this.carGroups.push(itm);
        }
      }
      this.productList[index].checked = false

      if(index==0){
        this.carGroups = [];
      }
    },
    //编辑数据
    edit(index, row) {
      this.$set(row, 'isEgdit', true)
    },
    //编辑成功
    editSuccess(index, row) {
      this.$set(row, 'isEgdit', false)
    },
    getProductMList() {
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
        // status:2,
        page:this.pageNumP,
        pageSize:this.pageSizeP
      }
      if (this.searchForm.product_id) param.product_type_id = this.searchForm.product_id
      if(this.searchForm.keywords) param.queryParams=this.searchForm.keywords;

      this.$axios.getParenInsure(param).then(res => {
        // console.log('res-param',param);
        // console.log('res-data',res);
        if (res.code == 200&&res.data.total>0) {
          this.productMList = res.data.data;
          this.totalP = res.data.total;
        }
      }).catch(error => {
        //console.log(error);
      })
    },
    clickChange(row,index,row2,index2){
      this.selectText = '已选择';
      this.noticeVisible=true;
      this.addForm.product_paren_id=row.id;
      this.currIndex=index2;
      this.addForm.product_md_name=row2.title;
      this.addForm.product_md_id=row2.id;
      this.addForm.price=row2.price;
      this.addForm.sell_price= row2.shopmd ? row2.shopmd[0]['sell_price'] :row2.sell_price;//row.sell_price; //row.sell_price;
      this.addForm.real_price=row2.real_price;
      this.cpys=row2.cpys;
      this.readNoticeTitle = '投保告知';
      let tmp= this.productMList[index];
      // console.log('tmp-data',tmp);
      let tmpSon = tmp.children[index2-1];
      this.productMList=[];
      tmp.children = [];
      // console.log('tmp-tmpSon',tmpSon);

      tmp.children.push(tmpSon)
      this.productMList.push(tmp)
      this.isUsed=true;
      this.productPage = false;
      if(this.reneInfo && this.reneInfo.star_times)
      {
        this.productList[0].checked = true
        this.getCurrentRow(this.productList[0],0)
      }else{
        //this.getCarList();
      }
      this.getCarList()
    },

    startDateChange(date,idx,register_date){
      //console.log('start_time----',date)
      //console.log('idx----',idx)
      this.list[idx].start_time= moment(date).format('YYYY-MM-DD')+" 00:00:00";
      let tmp=new Date(date);
     // this.list[idx].effective_date=this.getNextDate(tmp);
      this.list[idx].end_time=this.getNextYearDay(tmp);
      this.getTimeLimit(register_date,idx);
    },
    getTimeLimit(register_date,index){
      //var time_limit = "没有注册日期";
      if(register_date)
      {
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          register_date:register_date
        }
        this.$axios.getCarLimitTime(param).then(res=>{
          if(res.code == 200){
            console.log('timelimit:',res.data.time_limit);
            this.list[index].time_limit = res.data.time_limit
          }
        }).catch(error=>{

        })
      }
      // return time_limit;
    },
    getNextYearDay(date){
      var tmp= moment(date.getFullYear()+"-"+(date.getMonth()+1)+'-'+date.getDate()).add(1, 'y').format('YYYY-MM-DD');
      return  moment(tmp).subtract(1, 'days').format('YYYY-MM-DD 23:59:59');
    },
    getNextDate(date){
      var tmp= moment(date.getFullYear()+"-"+(date.getMonth()+1)+'-'+date.getDate()).add(-1, 'd').format('YYYY-MM-DD');
      console.log('tmp:',tmp);
      return  moment(tmp).format('YYYY-MM-DD HH:mm:ss');
    },
    getNowTime(y=0,m=0,d=0) {
      return moment().format("yyyy-MM-DD HH:mm:ss")
    },
    getNowDate(y=0,m=0,d=0,timestamp=null) {
      let now;
      if(timestamp)
      {
        now = new Date(timestamp);
      }else{
        now = new Date();
      }
      var year = now.getFullYear()+y; //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate()+d; //得到日期
      var hour =" 00:00:00"; //默认时分秒 如果传给后台的格式为年月日时分秒，就需要加这个，如若不需要，此行可忽略
      month = month + 1+m;
      month = month.toString().padStart(2, "0");
      date = date.toString().padStart(2, "0");
      var defaultDate = `${year}-${month}-${date} ${hour}`;
      //console.log(defaultDate)
      return defaultDate;

    },
    getToubaoDate(d)
    {
      var date = this.getNowDate()
      var times = 0;
      if(d>0)
      {
        times = 60*60*24*d;
        //增加时间戳
      }
      var timeDate = new Date(date);

      var timestamp = (timeDate.getTime())/1000 + times;
      //console.log('timestamp:',timestamp);
      date = this.getNowDate(0,0,0,timestamp*1000)
      return date;
    },
    arrayGroupBy(list, groupId){
      //根据数组属性分组 let json = this.arrayGroupBy(this.list,"type")
      function groupBy(array, f){
        const groups = {}
        array.forEach(function (o) {
          const group = JSON.stringify(f(o))
          groups[group] = groups[group] || []
          groups[group].push(o)
        })
        return groups;
      }
      return groupBy(list, function (item) {
        return item[groupId]
      });
    },
    //获取险种
    getProductList(){
      var param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
        pageNum:1,
        pageSize:100,
        pageType:1 // 公司行驶证页面 不显示 交强、商业险
      }
      if(this.reneInfo && this.reneInfo.plate_number)
      {
        param.plate_number = this.reneInfo.plate_number;
      }
      this.$axios.insuranceProdcutList(param).then(res=>{
        if(res.code == 200){
          this.productNameList = res.data.data
        }
        // console.log('productNameList',res.data.data);
      })
    },


    formatRichText(text) {
      return DOMPurify.sanitize(text);
    },
    //保费保障弹出层内容open
    okReadBx(){
      this.noticeBXVisible=false;
    },
    readNoticeBx(row){

      this.noticeBXData = row
      this.titleBx = row.product_md_title+' - 保费保障';
      this.noticeBXVisible=true;
    },
    //保费保障弹出层内容end
  },
  computed: {
    empty() {
      return empty
    },
    applicantSet() {
      return this.applicantStates.map(item => {
        return { id: `${item.id}`, name: `${item.name}-${item.name}` };
      });
    },
    corpSet() {
      return this.corpStates.map(item => {
        return { id: `${item.id}`, name: `${item.name}` };
      });
    },

  },
}
</script>
<style lang="less" scoped>
.upload_group {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  .upload_list {
    width: 100px;
    margin-right: 1rem;

  }

  /deep/.el-upload-dragger .el-upload__text {
    font-size: 10px;
    color: #409EFF;
  }

  /deep/.el-icon-upload:before {
    width: 30px !important;
    height: 30px !important;
  }
  .upload_list:last-child {
    margin-right: 0;
  }

  /deep/.el-upload-dragger {
    width: 100%;
    height: auto;
    padding: 20px 0;
    border: 1px solid #999;
  }

  /deep/.el-upload {
    width: 100%;
  }

  /deep/.el-upload-dragger .el-icon-upload {
    margin: 10px 0;
  }
}
.table_name:hover{
  color: #409EFF;
  cursor: pointer;
}
/deep/.el-table__body tr.current-row > td {
  background-color:#8cc5ff !important;
}


///deep/.el-upload-dragger {
//  width: 50px !important;
//  height: 50px !important;
//}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
}
.avatar {
  width: 50px !important;
  height: 50px !important;
  display: block;
}

.selected {
  background-color: #409EFF; /* 设置选中时的背景色 */
  color: #ffffff; /* 设置选中时的文字颜色 */
  /* 可以根据需求设置其他样式 */
}
.el-row .el-col-24 .else{
  margin: 20px;
  text-align: center;
  font-size: 20px;
}

</style>



// WEBPACK FOOTER //
// src/view/common/unionProductOrder.vue